import React from "react";
import { Link } from "react-router-dom";
import Highlight from "../Highlight";

export default function TwoWays() {
  return (
    <section
      id="two-ways"
      className="mx-auto max-w-[1200px] px-6 pb-12 pt-24 lg:px-10"
    >
      <div className="mb-3.5 text-[12px] font-bold uppercase leading-none tracking-[0.12em] text-coral-500">
        Two ways to work with Pro
      </div>
      <h2 className="mb-3 text-balance text-[clamp(32px,4vw,48px)] font-bold leading-[1.05] tracking-[-0.025em]">
        Self-serve or hands-off. <Highlight>Same bar.</Highlight>
      </h2>
      <p className="mb-12 max-w-[560px] text-[18px] font-medium leading-[1.5] text-warm-600">
        Every freelancer clears the same vetting either way &mdash; the only
        choice is how much you want us in the room.
      </p>

      <div className="grid grid-cols-1 gap-8 min-[900px]:grid-cols-2">
        {/* Marketplace — the self-serve path */}
        <div className="flex min-w-0 flex-col gap-[18px] rounded-3xl border-[1.5px] border-ink-v2 bg-white p-10 shadow-pop">
          <div className="flex items-center justify-between gap-4">
            <span className="rounded-full border-[1.5px] border-ink-v2 bg-lime-300 px-3.5 py-2 text-[12px] font-bold uppercase leading-none tracking-[0.12em]">
              Marketplace
            </span>
            <span className="text-[13px] font-medium leading-none text-warm-500">
              Self-serve
            </span>
          </div>
          <h3 className="text-[clamp(24px,2.6vw,32px)] font-bold leading-[1.15] tracking-[-0.02em]">
            Browse, pick, hire. Directly.
          </h3>
          <p className="text-[16px] leading-[1.55] text-warm-600">
            Search vetted profiles with real rates and availability. Message
            talent, agree scope, start same week. We handle contracts and
            payments in the background.
          </p>
          <ul className="mb-2 mt-1 flex list-none flex-col gap-2.5 p-0 text-[15px] font-medium leading-[1.4]">
            <li>&#10003; Transparent rates &mdash; no markups hidden in the middle</li>
            <li>&#10003; Contracts, invoicing &amp; payouts handled</li>
            <li>&#10003; Replace a mismatch free, within 14 days</li>
          </ul>
          <Link
            to="/talent"
            className="mt-auto self-start rounded-full bg-ink-v2 px-[26px] py-[15px] text-[15px] font-bold leading-none text-white transition-colors duration-120 hover:bg-coral-500 hover:text-white"
          >
            Browse talent &rarr;
          </Link>
        </div>

        {/* Managed — the done-for-you path */}
        <div className="flex min-w-0 flex-col gap-[18px] rounded-3xl border-[1.5px] border-ink-v2 bg-ink-v2 p-10 shadow-pop-coral">
          <div className="flex items-center justify-between gap-4">
            <span className="rounded-full border-[1.5px] border-coral-500 bg-coral-500 px-3.5 py-2 text-[12px] font-bold uppercase leading-none tracking-[0.12em] text-white">
              Managed &middot; Embedded
            </span>
            <span className="text-[13px] font-medium leading-none text-cream-100/60">
              Hands-off
            </span>
          </div>
          <h3 className="text-[clamp(24px,2.6vw,32px)] font-bold leading-[1.15] tracking-[-0.02em] text-cream-100">
            Brief us. We run the job.
          </h3>
          <p className="text-[16px] leading-[1.55] text-cream-100/75">
            Tell us the outcome you need. We assemble the right freelancer
            &mdash; or a small team &mdash; embed them in your workflow, and stay
            accountable for delivery.
          </p>
          <ul className="mb-2 mt-1 flex list-none flex-col gap-2.5 p-0 text-[15px] font-medium leading-[1.4] text-cream-100">
            <li>&#10003; Dedicated account lead on every engagement</li>
            <li>&#10003; Weekly delivery check-ins &mdash; we chase, not you</li>
            <li>&#10003; Scale from one freelancer to a full squad</li>
          </ul>
          <Link
            to="/for-companies"
            className="mt-auto self-start rounded-full border-[1.5px] border-coral-500 bg-coral-500 px-[26px] py-[15px] text-[15px] font-bold leading-none text-white transition-colors duration-120 hover:border-white hover:bg-white hover:text-ink-v2"
          >
            How managed works &rarr;
          </Link>
        </div>
      </div>
    </section>
  );
}
